module.exports = __webpack_public_path__ + "routes/login/pz_logo.svg?ca453bc7";


//////////////////
// WEBPACK FOOTER
// ./routes/login/pz_logo.svg
// module id = 1061
// module chunks = 0